import { render } from "./UserProfile.vue?vue&type=template&id=32b896f7&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=ts"
export * from "./UserProfile.vue?vue&type=script&lang=ts"

import "./UserProfile.vue?vue&type=style&index=0&id=32b896f7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32b896f7"

export default script